import { BAILocale } from '.';
import vi_VN from 'antd/es/locale/vi_VN';

const localeValue: BAILocale = {
  lang: 'vi',
  antdLocale: vi_VN,
};

export default localeValue;
